<template>
  <div
    class="cpt-user-spark-wrapper"
    @mouseenter="handleMouseEnter"
    v-tooltip="{
      text: tooltipContent,
      disable: tooltipContent === '',
    }"
  >
    <div class="spark-icon">
      <ChatImg :src="sparkConfig.icon"></ChatImg>
    </div>
    <div
      class="spark-count"
      v-if="showCount"
    >
      连续聊天 {{ spark.continuous_days }} 天
    </div>
  </div>
</template>

<script>
import {
  USER_SPARK_LEVEL,
  getSparkUserLevel,
  getSparkUserConfig,
} from '_lib/constants/spark';
import { mapGetters } from 'vuex';
export default {
  name: 'UserSpark',
  props: {
    spark: {
      type: Object,
      default: () => {},
    },
    showCount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      USER_SPARK_LEVEL,
    };
  },
  computed: {
    sparkLevel() {
      const days = this.spark.continuous_days;
      if (!days) return USER_SPARK_LEVEL.NONE;
      return getSparkUserLevel(days);
    },
    sparkConfig() {
      return getSparkUserConfig(this.sparkLevel);
    },
    tooltipContent() {
      if (this.sparkLevel === USER_SPARK_LEVEL.NONE) return '';
      const { level } = this.global_config.spark_user_level_config;
      return `在房间中连续发送消息超过 ${
        this.sparkLevel === USER_SPARK_LEVEL.SHORT
          ? level[USER_SPARK_LEVEL.SHORT]
          : level[USER_SPARK_LEVEL.LONG]
      } 天`;
    },
    ...mapGetters(['global_config']),
  },
  methods: {
    handleMouseEnter() {
      if (this.hoverAnimation) {
      }
    },
  },
};
</script>

<style lang="scss">
.cpt-user-spark-wrapper {
  display: flex;
  padding: 1px 4px;
  align-items: center;
  gap: 1px;
  box-sizing: border-box;
  border-radius: 3px;
  .spark-icon {
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    & > svg {
      margin-left: 0;
    }
  }
  .spark-count {
    margin-left: 3px;
    color: $d-op-5;
    text-align: center;

    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.12px;
  }
}
</style>
